module.exports = __webpack_public_path__ + "img/linkedin.6976c96a.png";